import { Cropper, Preview } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
export default Vue => {
  Vue.use(Cropper)
  Vue.use(Preview)
}
